define('views/modules/calendar/calendar/calendar-component/item/item-duplicate-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    'services/api',
    // events
    'services/events/calendar-events',
    // models
    'models/calendar/session',
    // views
    'views/parts/modal/modal',
    'views/parts/form/datepicker',
    'views/parts/form/choices',
    // templates
    'text!templates/modules/calendar/calendar/calendar-component/item/item-duplicate-modal.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    i18n, API,
    // events
    CalendarEvents,
    // models
    MSession,
    // views
    VModal,
    VDatePicker,
    VChoices,
    // templates
    TCalendarItemDuplicateModal
) {

    var VCalendarItemDuplicateModal = VModal.extend({
        template: TCalendarItemDuplicateModal,

        regions: {
            date: ".date-picker",
            duplicateAllItems: '.duplicate-all-items-checkbox'
        },

        modal: function() {
            return {
                title: i18n.t("calendar:Duplicate activity to"),
                size: "small",
                className: "calendar-item-duplicate-modal",
            };
        },

        initialize: function(options) {
            options = options || {}; // additional options passed to the constructor.

            this.duplicateModel = new Backbone.Model({ duplicateAll: false });
            this.view = {
                date: new VDatePicker({
                    label: false,
                    inline: true,
                    responsive: true,
                    multidate: true,
                    attribute: 'date',
                    model: this.model,
                    datepicker: {
                        todayHighlight: true
                    }
                }),
                duplicateAllItems: new VChoices({
                    label: 'calendar:Duplicate all items of the animated session',
                    model: this.duplicateModel,
                    attribute: 'duplicateAll'
                })
            };

            //this.IsAnimatedSession = false;
        },

        render: function() {
            var html = Mustache.render(
                                        this.template, Mustache.getContext({
                                            IsAnimatedSession: this.IsAnimatedSession
                                        }));
            this.$el.empty().append(html);
            this.generateZones()
                .assign(this.view.date, this.zone.$date)
                .assign(this.view.duplicateAllItems, this.zone.$duplicateAllItems)
                .renderModal();
            //this.view.date.setMultiDate([this.model.get('date')]); No preselection : David 11-01-2018
            return this;
        },

        setModel: function(model) {
            if (model) {
              this.model = model;
              this.setAnimatedSessionDisplay();
            }
            return this;
        },

        setAnimatedSessionDisplay: function() {
            if (this.model.get('type') === 'animated')
                this.IsAnimatedSession = true;
            else
                this.IsAnimatedSession = false;
            return this;
        },
        ////////////
        // events //
        ////////////
        onConfirm: function(confirmed) {
            if (!confirmed) return;

            var arrDate = this.view.date.getMultiValue();
            if (arrDate.length === 0) return;

            for (var i = 0; i < arrDate.length; i++) {
                var date = API.formatDate(arrDate[i]),
                    model = this.model,
                    target = model.duplicate({
                        date: date,
                        user: this.model.get("user"),
                        done: false,
                        feedback_level: 10,
                        feedback_comment: ""
                    });

                this.newDate = date;

                if (model.getType() === 'animated') {
                    var session = new MSession();
                    session.setId(model.get('session'));
                    session.fetch({
                        async: false,
                        context: this,
                        success: function(model) {
                            var newSession = model.duplicate({
                              _date: this.newDate,
                              user: this.model.get("user")
                            });

                            if (this.duplicateModel.get('duplicateAll') === false) {
                                newSession.set({ num_weeks: 1 });
                                newSession.get('exercises').forEach(function (ex) {
                                    ex.weeks = [ex.weeks[this.model.get('week')]];
                                }, this);
                            }

                            newSession.save(newSession.attributes, { success: this.onNewSessionSaved });
                        },
                        error: function(collection, response, options) {
                          //console.log(response);
                        }
                    });
                } else {
                    target.save(_.omit(target.attributes, 'garmin_summary_id'), { async: false }).then(CalendarEvents.itemUpdate(target));
                }
            }
        },

        onNewSessionSaved: function(model) {
            CalendarEvents.sessionUpdate(model);
        },
    });

    return VCalendarItemDuplicateModal;
});

